import TeamRolesTable from './TeamRolesTable';

export default TeamRolesTable;
